import { Moon, Sun, Monitor } from 'lucide-react'

import { cn } from '@/lib/utils'

import type { Theme } from '@/stores/ui.store'

interface ThemeIconProps {
  /** 主题类型 */
  theme: Theme
  /** 自定义类名 */
  className?: string
}

/**
 * 主题图标组件
 * 
 * 根据主题类型显示对应的图标：
 * - light: 太阳图标
 * - dark: 月亮图标
 * - system: 显示器图标
 */
export function ThemeIcon({ theme, className }: ThemeIconProps) {
  const iconClass = cn('h-4 w-4', className)

  switch (theme) {
    case 'light':
      return <Sun className={iconClass} />
    case 'dark':
      return <Moon className={iconClass} />
    case 'system':
      return <Monitor className={iconClass} />
    default:
      return <Monitor className={iconClass} />
  }
}

/**
 * 获取主题显示名称
 */
export function getThemeLabel(theme: Theme): string {
  switch (theme) {
    case 'light':
      return '亮色'
    case 'dark':
      return '暗色'
    case 'system':
      return '跟随系统'
    default:
      return '跟随系统'
  }
}
